import { useEffect, useState } from "react";
import FlexPassApi from "../../api/flexpassApi";
import { ReactComponent as CrossIcon } from "../../assets/General/close.svg";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import ModalWindow from "../../components/ModalWindow/ModalWindow";
import StandartButton from "../../components/StandartButton/StandartButton";
import TripleDotPoperMenu from "../../components/TripleDotPoperMenu/TripleDotPoperMenu";
import {
  FlexPassFilteres,
  FlexPassParamsAvailable,
  FlexPassSubscription,
} from "../../types/FlexPassTypes";
import Notify from "../../utils/toaster";
import CreateFlexPass from "./CreateFlexPass/CreateFlexPass";
import s from "./FlexPass.module.css";
import FlexPassFilters from "./FlexPassFilters/FlexPassFilters";
import { FlexPassInfo } from "./FlexPassInfo/FlexPassInfo";
import FlexPassTable from "./FlexPassTable/FlexPassTable";

const FlexPass = () => {
  const token = localStorage.getItem("token");
  const [filters, setFilters] = useState<FlexPassFilteres>({
    page: 1,
    limit: 5,
  });
  const [flexPasses, setFlexPasses] = useState<FlexPassSubscription[]>([]);
  const [paramsAvailable, setParamsAvailable] = useState<
    FlexPassParamsAvailable | undefined
  >();
  const [createFlexPassModal, setCreateFlexPassModal] = useState(false);
  const [passInfoModal, setPassInfoModal] = useState(false);
  const [selectedFlexPass, setSelectedFlexPass] = useState<
    FlexPassSubscription | undefined
  >();
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);

  const menuItems = [
    { title: "Update", action: () => setCreateFlexPassModal(true) },
    {
      title: "Delete",
      action: () => setDeleteConfirmModal(true),
      styles: { color: "red" },
    },
  ];

  const getFlexPasses = async () => {
    if (!token) return;
    const response = await FlexPassApi.getFilteredFlexPassSubscriptions(
      token,
      filters
    );

    if (response.status && response.subscriptions) {
      if (response.paramsAvailable) {
        setParamsAvailable(response.paramsAvailable);
      }

      setFlexPasses(response.subscriptions);
    }
  };

  useEffect(() => {
    getFlexPasses();
  }, [filters]);

  useEffect(() => {
    setPassInfoModal(selectedFlexPass ? true : false);
  }, [selectedFlexPass]);

  const deleteFlexPass = async () => {
    if (!token || !selectedFlexPass) return;
    const response = await FlexPassApi.deleteFlexPassSubscription(
      token,
      selectedFlexPass._id
    );
    if (response.status) {
      setFlexPasses((prev) =>
        prev.filter((el) => el._id !== selectedFlexPass._id)
      );
      setSelectedFlexPass(undefined);
      setPassInfoModal(false);
      setDeleteConfirmModal(false);
    }
    if (!response.status && response.message) {
      Notify(response.message);
    }
  };

  return (
    <div className={s.container}>
      <div className={s.actionBlock}>
        <StandartButton
          action={() => setCreateFlexPassModal(true)}
          buttonTitle="Create FlexPass"
        />
      </div>
      <div className={s.filtersBlock}>
        <FlexPassFilters
          filters={filters}
          paramsAvailable={paramsAvailable}
          setFilters={setFilters}
        />
      </div>
      <div className={s.tableBlock}>
        {flexPasses.length ? (
          <FlexPassTable
            count={paramsAvailable?.totalAmount ?? 0}
            page={filters.page}
            rows={flexPasses}
            rowsPerPage={filters.limit}
            setPage={(page: number) =>
              setFilters((prev) => ({ ...prev, page: page }))
            }
            setRowsPerPage={(limit: number) =>
              setFilters((prev) => ({ ...prev, limit: limit }))
            }
            setSelectedFlexPass={setSelectedFlexPass}
            setFlexPasses={setFlexPasses}
          />
        ) : (
          <h3 className={s.noFlexpassText}>No FlexPasses</h3>
        )}
      </div>
      <ModalWindow
        isOpen={createFlexPassModal}
        setIsOpen={setCreateFlexPassModal}
        width="fit-content"
      >
        <CreateFlexPass
          setFlexPasses={setFlexPasses}
          setCreateFlexPassModal={setCreateFlexPassModal}
          isUpdatePass={selectedFlexPass ? true : false}
          flexPassPropsData={selectedFlexPass}
          setSelectedFlexPass={setSelectedFlexPass}
        />
      </ModalWindow>
      {selectedFlexPass && (
        <ModalWindow
          isOpen={passInfoModal}
          alternativeCloseFunction={() => {
            setPassInfoModal(false);
            setSelectedFlexPass(undefined);
          }}
          width="fit-content"
        >
          <div className={s.headerActionBlock}>
            <TripleDotPoperMenu menuItemDta={menuItems} />
            <div
              onClick={() => {
                setSelectedFlexPass(undefined);
                setPassInfoModal(false);
              }}
              style={{ cursor: "pointer" }}
            >
              <CrossIcon className={s.closeIcon} />
            </div>
          </div>
          <FlexPassInfo
            data={selectedFlexPass}
            setInfoModalIsOpen={setPassInfoModal}
            setFlexPasses={setFlexPasses}
            setSelectedFlexPass={setSelectedFlexPass}
          />
        </ModalWindow>
      )}
      <ConfirmationModal
        confirmFunc={deleteFlexPass}
        modalVisible={deleteConfirmModal}
        setModalVisible={setDeleteConfirmModal}
        confirmTitle="Are you sure you want to delete this FlexPass?"
      />
    </div>
  );
};

export default FlexPass;
